import { Box, styled } from '@mui/material';

export const FilterRangeContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(1, 2),
}));
